import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Modal } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';

const LanguagePopup = (props) => {
    const { setIsModalOpen, isModalOpen } = props;
    const { langList, changeLanguage, lang } = useLanguage();
    
    const [language, setlanguage] = useState(lang);

    const onContinueClickHandler = () => {
        changeLanguage(language, true);
        setIsModalOpen(false);
    };
    return (
        <Modal
            title='Select language'
            open={isModalOpen}
            onOk={() => onContinueClickHandler()}
            onCancel={() => setIsModalOpen(false)}
            rootClassName='language-modal'
            centered
            width='18rem'
            okText='Continue'
            cancelButtonProps={{
                hidden: true,
            }}
        >
            <div className='content-area'>
                {langList.map((item) => (
                    <div
                        className={
                            'lang-card ' +
                            (item.lang_code === language ? 'selected' : '')
                        }
                        key={item.id}
                        onClick={() => setlanguage(item.lang_code)}
                    >
                        <span>{item.lang_name}</span>
                        {item.lang_code === language && (
                            <span>
                                <CheckCircleTwoTone twoToneColor='green' />
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </Modal>
    );
};
export default LanguagePopup;
